exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".info-section[data-v-08de9fd9] {\n  height: 100vh;\n  width: 50%;\n  background: white;\n  padding: 72px;\n  position: relative;\n  z-index: 10;\n  overflow-y: auto;\n  overflow-x: hidden;\n  white-space: nowrap;\n}\n", ""]);

// exports
